<template>
  <div class="home">
    <NavbarMain />
    <div class="content-fix">
      <div
        class="container pt-5 px-0 px-xl-2"
        v-if="this.products.length > 0 || this.services.length > 0"
      >
        <table class="table">
          <thead class="text-center bg-blue">
            <tr>
              <th scope="col" class="d-none d-sm-table-cell"></th>
              <th scope="col">Titulo</th>
              <th scope="col" class="d-none d-xl-table-cell">Precio SC$</th>
              <th scope="col" class="d-none d-sm-table-cell">
                Precio vendedor
              </th>
              <th scope="col">Estado</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody class="text-center">
            <tr v-for="product in products" :key="product._id">
              <td class="d-none d-sm-table-cell">
                <img
                  class="img-fluid img-thumbnail"
                  v-bind:src="
                    url +
                    'public/images/products/' +
                    (product.images[0] ? product.images[0] : 'blank.png')
                  "
                  alt="Card image cap"
                  style="height: 60px !important"
                />
              </td>
              <td class="align-middle">
                <router-link
                  v-if="product.state == 1"
                  :to="{
                    name: 'product',
                    params: {
                      id: product._id,
                      title: product.name.replace(/\s/g, '-'),
                    },
                  }"
                  >{{ product.name }}</router-link
                >
                <span v-else>{{ product.name }}</span>
              </td>
              <td class="align-middle d-none d-xl-table-cell">
                SC$ {{ localToSC(product.price, product.currency) }}
              </td>
              <td class="align-middle d-none d-sm-table-cell">
                {{ product.currency }}$ {{ product.price.toFixed(2) }}
              </td>
              <td class="align-middle">
                <BadgeState :state="product.state" />
              </td>
              <td class="align-middle">
                <router-link
                  :to="{
                    name: 'Publication',
                    params: {
                      id: product._id,
                      title: product.name.replace(/\s/g, '-'),
                    },
                  }"
                >
                  <span class="material-icons text-info cursor-pointer"
                    >settings</span
                  >
                </router-link>
              </td>
            </tr>
            <!-- Servicios -->
            <tr v-for="service in services" :key="service._id">
              <!-- Imagen -->
              <td class="d-none d-sm-table-cell">
                <img
                  class="img-fluid img-thumbnail"
                  v-bind:src="
                    url +
                    'public/images/services/' +
                    (service.images[0] ? service.images[0] : 'blank.png')
                  "
                  alt="Card image cap"
                  style="height: 60px !important"
                />
              </td>
              <!-- Nombre -->
              <td class="align-middle">
                <router-link
                  v-if="service.state == 1"
                  :to="{
                    name: 'service',
                    params: {
                      id: service._id,
                      title: service.name.replace(/\s/g, '-'),
                    },
                  }"
                  >{{ service.name }}</router-link
                >
                <span
                  v-if="service.state == 0 || service.state == 2"
                  title="El servicio se encuentra en espera o cancelado."
                >
                  {{ service.name }}
                </span>
                <span v-if="service.state == 4">
                  {{ service.name }}
                </span>
              </td>
              <!-- Precio SC -->
              <td class="align-middle d-none d-xl-table-cell">
                SC$ {{ localToSC(service.price, service.currency) }}
              </td>
              <!-- Precio Local -->
              <td class="align-middle d-none d-sm-table-cell">
                {{ service.currency == "USA" ? "USD" : service.currency }}${{
                  service.price.toFixed(2)
                }}
              </td>
              <!-- Estado -->
              <td class="align-middle">
                <BadgeState :state="service.state" />
              </td>
              <!-- Modificar -->
              <td class="align-middle">
                <router-link
                  :to="{
                    name: 'PublicationService',
                    params: {
                      id: service._id,
                      title: service.name.replace(/\s/g, '-'),
                    },
                  }"
                >
                  <span class="material-icons text-info cursor-pointer"
                    >settings</span
                  >
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="container container-sin-publicaciones"
        v-if="this.products.length == 0 && this.services.length == 0"
      >
        <div class="row justify-content-center align-items-center py-5 mt-3">
          <div class="col-12 mb-5">
            <h4 class="text-center">
              Aún no tienes publicaciones disponibles.
            </h4>
            <h2 class="text-center mt-5">
              Realiza tu primer publicación ahora!
            </h2>
          </div>
          <div class="col-6">
            <router-link
              class="btn btn-block btn-treid text-uppercase"
              :to="{ name: 'SellerProduct' }"
              >Publicar un producto</router-link
            >
          </div>
          <div class="col-6">
            <router-link
              class="btn btn-block btn-treid text-uppercase"
              :to="{ name: 'SellService' }"
              >Publicar un servicio</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import Api from "@/tools/Api2";
import Configs from "@/configs/configs";
import { mapState } from "vuex";
import { LC } from "../../tools/exchange";
import BadgeState from "../../components/badges/BadgeState.vue";
export default {
  name: "Publications",
  components: {
    NavbarMain,
    BadgeState,
  },
  data() {
    return {
      products: [],
      services: [],
      url: Configs.API.BASE,
      localCurrency: null,
    };
  },
  computed: {
    ...mapState(["auth", "changes"]),
  },
  created: async function () {
    LC.new().then((localCurrency) => {
      this.localCurrency = localCurrency;
    });
    Api("product?filter[sellerId]=" + this.auth.id)
      .get()
      .then((res) => {
        this.products = res.products.filter((e) => e.state != 3);
      });

    Api("service?filter[sellerId]=" + this.auth.id)
      .get()
      .then((res) => {
        this.services = res.services.filter((e) => e.state != 3);
      });
  },
  methods: {
    localToSC(price, currency) {
      if (!this.localCurrency) return "-";
      return this.localCurrency.localToSC({ price, currency }).toFixed(2);
    },
  },
};
</script>


<style scoped>
.home {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content-fix {
  flex-grow: 1;
}

#footer {
  position: relative;
  bottom: 0;
}
</style>
